// removed by extract-text-webpack-plugin
module.exports = {"Hero":"src-components-ProgramOverview-Hero----Hero-module---Hero---2oEUq","Hero__Green":"src-components-ProgramOverview-Hero----Hero-module---Hero__Green---9kRq_","Hero__Underline__Green":"src-components-ProgramOverview-Hero----Hero-module---Hero__Underline__Green---MlpYd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgramOverview/Hero/Hero.module.scss
// module id = 737
// module chunks = 168707334958949